module.exports = __webpack_public_path__ + "static/media/zoltan-tasi-k4kK9_OQk24-unsplash.9a733823.jpg";